import styled from "@emotion/styled"
import { PButtonPure } from "@porsche-design-system/components-react"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { DatePrice } from "@slfinrtl/ui-bff-routes"
import { useCallback, useMemo, useState } from "react"
import { defineMessages, FormattedMessage, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { List } from "../../../../list/List"

const messages = defineMessages({
	title: {
		defaultMessage: "Price history",
		id: "priceHistory.title",
	},
})

interface PriceHistoryProps {
	view: DatePrice[]
}

const MAX_ITEMS = 3

export const PriceHistory = ({ view }: PriceHistoryProps) => {
	const [hasMore, setHasMore] = useState(false)
	const { formatMessage } = useIntl()

	const toggleHasMore = useCallback(() => setHasMore((prev) => !prev), [setHasMore])

	const items = useMemo(() => (hasMore ? view : view.slice(0, MAX_ITEMS)), [view, hasMore])

	return (
		<div>
			<List header={formatMessage(messages.title)}>
				{items.map((item, index) => (
					<List.Item key={index} label={item.date} value={item.price} />
				))}
			</List>
			{view.length > MAX_ITEMS && (
				<StyledButtonPure icon="none" underline onClick={toggleHasMore}>
					<FormattedMessage {...(hasMore ? commonMessages.showLess : commonMessages.showMore)} />
				</StyledButtonPure>
			)}
		</div>
	)
}

const StyledButtonPure = styled(PButtonPure)`
	margin-top: ${spacingStaticSm};
`
